import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const DASHBOARD_NAMESPACE = 'dashboards'

export const Dashboard = {
  namespaced: true,
  state: {},
  actions: {
    getMetrics: async () => {
      return axiosRequest.
        get('/dashboard_metrics').
        then(({ data }) => data).
        catch(handleError)
    },
  },
  mutations: {},
  getters: {},
}
